import React, { ComponentProps, FunctionComponent } from "react";

const PhoneIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 12",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M11.9996 8.98431V10.7908C12.0003 10.9585 11.9659 11.1245 11.8986 11.2781C11.8313 11.4318 11.7325 11.5697 11.6087 11.6831C11.4849 11.7965 11.3387 11.8828 11.1795 11.9365C11.0203 11.9903 10.8517 12.0102 10.6843 11.9951C8.82768 11.7938 7.04426 11.1606 5.47734 10.1465C4.01953 9.22196 2.78356 7.98843 1.8572 6.53351C0.837516 4.96259 0.202945 3.17405 0.00489727 1.31277C-0.0101803 1.14625 0.00964865 0.978426 0.0631214 0.819976C0.116594 0.661526 0.202539 0.515923 0.315485 0.392439C0.42843 0.268955 0.565901 0.170295 0.719145 0.10274C0.87239 0.0351852 1.03805 0.000215834 1.20558 5.83809e-05H3.01565C3.30846 -0.00281781 3.59233 0.100667 3.81435 0.291223C4.03636 0.481779 4.18138 0.746405 4.22236 1.03578C4.29876 1.61389 4.44044 2.18152 4.64471 2.72785C4.72589 2.94338 4.74346 3.17761 4.69534 3.4028C4.64721 3.62799 4.53542 3.83469 4.3732 3.99841L3.60694 4.76315C4.46585 6.27069 5.71655 7.51891 7.22708 8.37612L7.99334 7.61138C8.15739 7.44948 8.3645 7.33791 8.59013 7.28988C8.81577 7.24185 9.05047 7.25939 9.26642 7.3404C9.81383 7.54427 10.3826 7.68567 10.9619 7.76192C11.2549 7.80318 11.5226 7.95052 11.714 8.1759C11.9053 8.40128 12.007 8.68899 11.9996 8.98431Z",
    })
  );
};

const ForwardRef = React.forwardRef(PhoneIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
